import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import PopupAd from './PopupAd';
import { isAdminEmail } from '../../utils/adminAccess';
import { usePremium } from '../../premium/PremiumContext';

const isPrivateAdminRoute = (pathname) => (
  pathname === '/admin' ||
  pathname.startsWith('/admin/') ||
  Boolean(matchPath({ path: '/shows/:id/edit-show', end: true }, pathname))
);

export default function RouteAdminPopupAd({ user }) {
  const { pathname } = useLocation();
  const { isPremium, premiumLoading } = usePremium();
  const isAdmin = Boolean(user?.email && isAdminEmail(user.email));

  if (premiumLoading || isPremium || !isAdmin || !isPrivateAdminRoute(pathname)) {
    return null;
  }

  return <PopupAd key={`popup-${pathname}`} />;
}
